<template>
	<el-main class="Team">
		<ContentNav :bannerTextIMG="require('../../assets/Team/bannerText.png')" :bannerimgIMG="require('../../assets/Team/banner.png')"></ContentNav>
		<div class="content">
			<div class="container">
				<Menu :Menulist="{MenuList}" :checkedValue="lawyerType" @changeNavIndex="loadLawyer"></Menu>
				<!-- 详情 -->
				<div class="details">
					<div class="details-item">
						<div class="details-title">{{detailsModel.name}}</div>
						<div class="UuerInfo">
							<div class="UserImg">
								<img :src="Url.imgUrl+detailsModel.photo" alt="" />
							</div>
							<div class="Userlabel">
								<div class="label-item">
									<div class="title">
										<img src="../../assets/Team/hz.png" alt />职务
									</div>
									<el-divider class="bottom"></el-divider>
									<div class="context">{{detailsModel.lawyerTypeName}}</div>
								</div>
								<div class="label-item">
									<div class="title">
										<img src="../../assets/Team/hz.png" alt />专业领域
									</div>
									<el-divider class="bottom"></el-divider>
									<div class="context">{{detailsModel.professionalFieldName}}</div>
								</div>
								<div class="label-item">
									<div class="title">
										<img src="../../assets/Team/hz.png" alt />详细介绍
									</div>
									<el-divider class="bottom"></el-divider>
								</div>
							</div>
						</div>
						<div class="Userdetails" v-html="detailsModel.introduce"></div>
					</div>
					<div class="details-item mt-3">
						<div class="details-title"><span>相关{{lawyerTyoeName||'人员'}}</span><span class="title-showalllist" @click="showAllList">看全部 →</span></div>
						<el-carousel height="250px" indicator-position="outside" arrow="never">
							<el-carousel-item v-for="(item,index) in relatedLawyer" :key="index">
								<div class="BoxList">
									<div class="BoxList-item" v-for="(x,i) in item" :key="i">
										<div class="UserImg">
											<img :src="Url.imgUrl+x.photo" alt="" />
										</div>
										<div class="UserInfo">
											<div class="Name">{{x.name}}</div>
											<div class="title">{{x.lawyerType}}</div>
											<div class="more" @click="showDetails(x.id)">详情>>></div>
										</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
			</div>
		</div>
		<Icongroup></Icongroup>
	</el-main>
</template>

<script>
	import ContentNav from "../../components/ContentNav";
	import Menu from "../../components/Menu";
	import Icongroup from "../../components/Icon_group";

	export default {
		components: {
			ContentNav,
			Menu,
			Icongroup
		},
		props: ["lawyerType", "id"],
		data() {
			return {
				MenuList: [],
				detailsModel: {}, //个人详情
				relatedLawyer: [], //相关律师
				navCheckedIndex: 0,
				lawyerTypeNum: 0,
				lawyerTyoeName: ''
			};
		},
		created() {
			this.getDetails();
		},
		methods: {
			//展示律师详情
			// showDetails(item) {
			// 	this.detailsModel = item;
			// 	console.log(item);
			// 	//筛选相关律师
			// 	let relatedLawyer = []
			// 	this.ALlLawyersList.forEach((x) => {
			// 		if (x.lawyerType == item.lawyerType && x.name != item.name) {
			// 			relatedLawyer.push(x)
			// 		}
			// 	});
			// 	this.relatedLawyer = relatedLawyer;
			// },
			loadNav() {
				//初始化路径数据
				this.$store.state.Currentposition = [{
					path: '/',
					name: '首页'
				}, {
					path: '/team',
					name: '专业团队'
				}]
			},
			loadLawyer(num) {
				console.log(num);
			},
			loadLawyerType() {
				let that = this;
				console.log(that.lawyerType);
				if ((that.lawyerType || '') == '') {
					//确认默认选择项id
					that.lawyerTypeNum = 0;
					that.lawyerTyoeName = '';
					that.getSimilarLawyer();
				}
				//获取律师类别
				that.axios({
					type: "get",
					url: that.Url.apiUrl + "Lawyer/GetLawyerType",
				}).then((res) => {
					let data = new Array();
					data.push({
						id: 0,
						name: "全部",
						value: '',
						route: {
							path: "/team.html"
						}
					});
					let len = res.data.length;
					for (let i = 0; i < len; i++) {
						if (that.lawyerType == res.data[i].enName) {
							//确认默认选择项id
							that.lawyerTypeNum = res.data[i].id;
							that.lawyerTyoeName = res.data[i].name;
							that.getSimilarLawyer();
						}

						data.push({
							id: res.data[i].id,
							name: res.data[i].name,
							value: res.data[i].enName,
							route: {
								name: 'team',
								params: {
									'lawyerType': res.data[i].enName
								}
							}
						});
					}

					that.MenuList = data;
					//that.getList();
				});
			},
			getDetails(id) {
				let that = this;
				id = id || that.id;
				//获取律师类别
				that.axios({
					type: "get",
					url: that.Url.apiUrl + "Lawyer/GetLawyer",
					params: {
						id: id
					}
				}).then((res) => {
					console.log(res.data);
					this.detailsModel = res.data;
				}).catch(()=>{
					alert("接口异常，请刷新重试")
				});
			},
			//筛选相关律师
			getSimilarLawyer() {
				let that = this;
				//筛选相关律师
				that.axios({
					type: "get",
					url: that.Url.apiUrl + "Lawyer/GetSimilarLawyer",
					params: {
						id: that.id,
						lawyerType: that.lawyerTypeNum,
						top: 6
					}
				}).then((res) => {
					console.log(res)
					let index = 0;
					let count = 2;
					let arrTemp = [];
					let data = res.data;
					let len = data.length;

					for (let i = 0; i < len; i++) {
						index = parseInt(i / count);
						if (arrTemp.length <= index) {
							arrTemp.push([]);
						}
						arrTemp[index].push(data[i])
					}
					that.relatedLawyer = arrTemp;
					console.log(that.relatedLawyer);
				});
			},
			showAllList(){
				let that = this;
				if((that.lawyerType || '') == ''){
					that.$router.push({
						path: "/team.html"
					});
					
				}else{
					that.$router.push({
						name: 'team',
						params: {
							'lawyerType': that.lawyerType
						}
					});
				}
			},
			showDetails(id) {
				let that = this;
				if((that.lawyerType || '') == ''){
					that.$router.push({
						name: 'team-all-details',
						params: {
							'id': id
						}
					});
				}else{
					that.$router.push({
						name: 'team-details',
						params: {
							'id': id,
							'lawyerType': that.lawyerType
						}
					});
				}
				that.getDetails(id);
			},
		},
		mounted() {
			//初始化路径数据
			this.loadNav();
			//获取律师类别
			this.loadLawyerType();
		}
	};
</script>

<style lang="scss" scoped>
	.content {
		position: relative;
		width: 100%;

		.container {
			position: relative;
			width: 1200px;
			display: flex;
			margin: 0 auto;
			padding: 40px 0;
			justify-content: space-between;

			@media screen and (max-width: 768px) {
				width: 100%;
				display: block;
				padding: 26px 21px;
			}

			.menu {
				@media screen and(max-width: 768px) {
					display: none;
				}
			}

			.selectBox {
				flex: 0 0 950px;

				@media screen and (max-width: 768px) {
					width: 100%;
				}

				.selectBox-item {
					width: 100%;
					display: flex;
					height: 40px;
					margin-bottom: 15px;
					justify-content: space-between;

					.title {
						display: flex;
						align-items: center;
						color: #707070;
						flex: 0 0 30%;

						@media screen and (max-width: 768px) {
							display: none;
						}
					}
				}

				.pinyin {
					display: flex;
					justify-content: space-between;
					color: #707070;
					font-size: 14px;

					span {
						cursor: pointer;
					}

					@media screen and (max-width: 768px) {
						flex-wrap: wrap;
						line-height: 25px;
						background-color: #fff;

						span {
							display: block;
							flex: 0 0 12.5%;
							text-align: center;
						}
					}
				}

				.BoxList {
					position: relative;
					display: flex;
					justify-content: space-between;
					align-items: center;
					flex-wrap: wrap;
					width: 100%;
					margin-top: 30px;

					@media screen and (max-width: 768px) {
						width: 100%;
					}

					.BoxList-item {
						flex: 0 0 460px;
						width: 460px;
						height: 180px;
						background-color: #ffffff;
						box-shadow: 0px 0px 6px 0px rgba(166, 166, 166, 0.3);
						border-radius: 4px;
						margin: 15px 0;
						display: inherit;

						@media screen and (max-width: 768px) {
							display: flex;
							flex: 0 0 100%;
							width: 100%;
							height: 109px;
							overflow: hidden;
						}

						.UserImg {
							width: 180px;
							height: 100%;
							flex: 0 0 180px;
							overflow: hidden;

							@media screen and (max-width: 768px) {
								flex: 0 0 109px;
								width: 109px;
								height: 100%;
							}

							img {
								width: 180px;
								height: auto !important;

								@media screen and (max-width: 768px) {
									width: 109px;
								}
							}
						}

						.UserInfo {
							padding: 30px 21px;
							width: calc(100% - 180px);
							flex: 0 0 calc(100% - 180px);
							height: 100%;
							position: relative;

							@media screen and (max-width: 768px) {
								padding: 16px;
								flex: 0 0 calc(100% - 109px);
							}

							.Name {
								font-size: 16px;
								color: #202020;
								line-height: 24px;
								font-weight: 600;
							}

							.title {
								color: #202020;
								line-height: 30px;
								font-size: 15px;
							}

							.more {
								color: #d0a971;
								font-size: 14px;
								position: absolute;
								bottom: 20px;
								right: 20px;
								cursor: pointer;
							}
						}
					}
				}
			}

			.details {
				flex: 0 0 950px;
				display: block;

				.details-title {
					color: #ae8a55;
					font-weight: 600;
					margin-bottom: 28px;
					display: flex;
					justify-content: space-between;

					@media screen and (max-width: 768px) {
						text-align: center;
					}

				}

				.title-showalllist {
					font-size: 14px;
					cursor: pointer;
				}

				.UuerInfo {
					width: 100%;
					display: flex;
					justify-content: space-between;
					height: auto;

					@media screen and(max-width: 768px) {
						display: block;
					}

					.UserImg {
						flex: 0 0 210px;
						width: 210px;
						height: 210px;
						overflow: hidden;

						@media screen and(max-width: 768px) {
							width: 129.6px;
							height: 166px;
							margin: 0 auto;
						}

						img {
							width: 210px;
							height: auto;

							@media screen and(max-width: 768px) {
								width: 129.6px;
							}
						}
					}

					.Userlabel {
						display: block;
						width: 710px;
						overflow: hidden;

						@media screen and(max-width: 768px) {
							width: 100%;
						}

						.label-item {
							height: 83px;
							position: relative;

							@media screen and(max-width: 768px) {
								height: auto;
							}

							.bottom {
								position: absolute;
								top: 9px;

								@media screen and(max-width: 768px) {
									top: 0px;
								}
							}

							.title {
								width: 238px;
								height: 33px;
								background-color: #caa165;
								color: #fff;
								line-height: 33px;

								@media screen and(max-width: 768px) {
									width: 142px;
									height: 24.2px;
									line-height: 24.2px;
									font-size: 13px;
								}

								img {
									margin: 0 10px;
								}
							}

							.context {
								display: block;
								padding: 0 30px;
								height: 50px;
								line-height: 50px;
								color: #787878;

								@media screen and(max-width: 768px) {
									font-size: 11px;
								}
							}
						}
					}
				}

				.Userdetails {
					color: #787878;
					font-size: 14px;
					line-height: 24px;
				}

				.BoxList {
					display: flex;
					justify-content: space-between;

					@media screen and(max-width: 768px) {
						display: block;
					}

					.BoxList-item {
						flex: 0 0 460px;
						width: 460px;
						height: 180px;
						background-color: #ffffff;
						box-shadow: 0px 0px 6px 0px rgba(166, 166, 166, 0.3);
						border-radius: 4px;
						margin: 15px 0;
						display: inherit;

						@media screen and(max-width: 768px) {
							width: 308px;
							height: 106px;
							margin: 15px auto;
							display: flex;
						}

						.UserImg {
							width: 180px;
							height: 100%;
							overflow: hidden;

							@media screen and(max-width: 768px) {
								width: 109px;
							}

							img {
								width: 180px;
								height: auto !important;

								@media screen and(max-width: 768px) {
									width: 109px;
									height: auto !important;
								}
							}
						}

						.UserInfo {
							padding: 25px 21px;
							width: calc(100% - 180px);
							height: 100%;
							position: relative;

							@media screen and(max-width: 768px) {
								padding: 16px;
								width: calc(100% - 109px);
								height: auto !important;
							}

							.Name {
								font-size: 14px;
								color: #202020;
								line-height: 24px;
								font-weight: 600;
							}

							.title {
								color: #202020;
								line-height: 24px;
								font-size: 14px;
							}

							.more {
								color: #d0a971;
								font-size: 14px;
								position: absolute;
								bottom: 20px;
								right: 20px;
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}

	.mt-3 {
		margin-top: 30px;
	}
</style>
